import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styles from './addAccountButton.module.scss';

interface Props {
  onClick?: () => void;
}

const AddAccountButton = ({ onClick }: Props) => {
  return (
    <button type="button" className={`btn ${styles.addButton}`} onClick={onClick}>
      <FontAwesomeIcon icon="plus" />
    </button>
  )
}

export default AddAccountButton;
